import React from 'react';
import { PropsWithChildren } from '../../../types/props-with-children';

interface AriaLiveWrapperProps {
    announce?: boolean;
}

export const AriaLiveWrapper: React.FC<PropsWithChildren<AriaLiveWrapperProps>> = (
    props: PropsWithChildren<AriaLiveWrapperProps>
) => {
    const { announce = true, children } = props;

    return <span aria-live={announce ? 'polite' : undefined}>{children}</span>;
};
